import type { TFunction } from 'i18next';
import type { Patient } from '../types/weekOverview';

// Unassigned seats are labelled from their parts ("Unassigned patient N ·
// plan") so the wording lives in i18n and overlapping plans stay
// distinguishable (each plan can have its own "patient 1"). Real patients keep
// their name.
export function patientDisplayName(patient: Patient, t: TFunction): string {
  if (!patient.isUnassigned) return patient.name;
  const base = t('week-overview-unassigned-patient', { number: patient.seatNumber ?? 1 });
  return patient.treatmentPlanName ? `${base} · ${patient.treatmentPlanName}` : base;
}
